import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon'

import NotFoundPage from '@pages/NotFoundPage';
import ButtonPage from '@pages/ButtonPage';
import FormPage from '@pages/FormPage';
import UnsubscribePage from '@pages/UnsubscribePage';

function App() {
  const { i18n } = useTranslation();

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale={i18n.language}>
      <Router>
        <Routes>
          <Route path="/button/:key" element={<ButtonPage />} />
          <Route path="/form/:key" element={<FormPage />} />
          <Route path="/unsubscribe/:key" element={<UnsubscribePage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </LocalizationProvider>
  );
}

export default App;
